module.exports = __webpack_public_path__ + "img/b5.861aaf09.png";